import React from "react";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const LogoMiniDark = ({
  height = normalize(17),
  width = normalize(26),
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M23.755 16.554c-.633 0-1.165-.216-1.597-.648-.432-.432-.648-.972-.648-1.62 0-.663.216-1.196.648-1.597.432-.416.964-.625 1.597-.625.632 0 1.165.209 1.597.625.432.401.648.934.648 1.597 0 .648-.216 1.188-.648 1.62-.432.432-.965.648-1.597.648Z"
      fill="#007EFC"
    />
    <Path
      d="m15.064 16.554-.023-9.932-4.872 8.182H8.443l-4.848-7.97v9.72H0V0h3.169l6.196 10.287L15.466 0h3.146l.047 16.554h-3.595Z"
      fill="#0D0D37"
    />
  </Svg>
);

export default LogoMiniDark;
